<script lang="ts" setup>
definePageMeta({
  validate: validateAndCacheEntity('offer', fetchOfferBySlug),
  authType: 'public',
})

const slugId = computed(() => useSlugId().value._unsafeUnwrap())
const { data: offer, suspense } = useOfferBySlug(slugId)
onServerPrefetch(async () => {
  await suspense()
})

useSeoMeta({
  title: computed(() => offer.value?.name ?? ''),
})
</script>

<template>
  <div v-if="offer">
    <AlOfferHeader :offer="offer" />

    <AlCmsPageSection
      v-for="section of offer.cms_page_section"
      :key="section.id"
      :section="section"
    />

    <AlOfferPageShowcase :offer="offer" />
  </div>
  <div v-else />
</template>
